import { useQuery } from "react-query";
import { getAllImages } from "../services/SlideApi";

const useGallery = () => {
    return useQuery('images', () => getAllImages())
}
 
export default useGallery;